import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showLoginPopup } from '../redux/actions';

const useCheckLogin = () => {
  const isLogin = useSelector((state) => state.loginInfo.flag);
  const dispatch = useDispatch();

  const check = useCallback(() => {
    if (!isLogin) {
      dispatch(showLoginPopup());
    }

    return isLogin;
  }, [isLogin]);

  return check;
};

export default useCheckLogin;
